import { createAction } from "@reduxjs/toolkit";

import { createManualVerificationActionTypes } from "./actionTypes";
import { createConsentFormActionTypes } from "../consentForms/actionTypes";

export const createManualVerification = createAction(
  createManualVerificationActionTypes.request,
  (payload) => ({ payload }),
);

export const createManualVerificationSuccess = createAction(
  createConsentFormActionTypes.success,
  (payload) => ({ payload }),
);
export const createManualVerificationFailure = createAction(
  createConsentFormActionTypes.failure,
  (payload) => ({ payload }),
);
